import { Template } from "./template.js";
import { Left_menu } from "./left_menu/component.js";
import { Info_window } from "./info_window/component.js";

const OneWireData = {
  name: "onewire",
  components: {
    "left-menu": Left_menu,
    "info-window": Info_window,
  },
  template: Template,
  data: function () {
    return {
      modems: [],

      selectedModem: null,

      selectedModemLogs: {},
    };
  },

  created() {
    // Первый запуск
    this.getModems();
  },
  beforeDestroy() {
    // при выходе - убиваем таймер аякса
    clearInterval(this.intervalID);
  },
  methods: {
    modemClick(modem) {
      this.selectedModem = modem; // info_window увидит это, и отрисует график
    },
    getModems() {
      //запускаем аякс из плагина
      this.$API(
        "static_data",
        "modems",
        {},
        (data) => {
          this.modems = data;
        },
        (errorText) => {
          console.log(errorText);
        }
      );
    },
    onSelectedDataLoad(data) {
      this.selectedModemLogs = data;
    },
  },
};

export { OneWireData };



// WEBPACK FOOTER //
// ./src/app/js/components/onewire/component.js